<template>
  <div class="foot w">
    <div class="logo" v-if="isShowLogo">
      <img src="./logo.png" alt="易极云课堂" />
    </div>
    <div class="introduce">
      <ul class="clearfix">
        <li>
          <!--<router-link to="/aboutUs" target="_blank">-->
          <!-- 取消关于我们6-27 -->
          <!-- <router-link to="/aboutdownload" target="_blank">
            {{ $t("footer.aboutUs") }}
          </router-link> -->
        </li>
        <li>
          <!-- 取消关于我们6-27 -->
          <!-- <router-link to="/merchants" target="_blank">
            {{ $t("footer.joinInvestment") }}
          </router-link> -->
          <!--<a href="javascript:void(0)">{{ $t('footer.joinInvestment') }}</a>-->
        </li>
        <!-- <li> -->
        <!--<router-link to="/AboutCompany/ContactUs" target="_blank">-->
        <!--{{ $t('footer.contactUs') }}-->
        <!--</router-link>-->
        <!-- <a> {{ $t('footer.contactUs') }}</a> -->
        <!-- </li> -->
      </ul>
      <!--<p>{{ $t('footer.msg') }}</p>-->
      <p>
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
          style="color: #A9A9A9"
        >
          蜀ICP备11021853号-2
        </a>
        Copyright © 2008-{{ currentYear }}
        <span style="color: #A9A9A9">
          易极云课堂 版权所有 All Rights Reserved
        </span>
      </p>
    </div>
    <div class="followus clearfix">
      <div
        class="follow-weiBo"
        @mouseenter="weiBoShow = true"
        @mouseleave="weiBoShow = false"
      >
        <i class="iconfont icon-shouji"></i>
        <a href="javascript:void(0)">
          <span class="weiBo">
            {{ $t("footer.shouji") }}
          </span>
        </a>
      </div>
      <div
        class="follow-weChat"
        @mouseenter="codeShow = true"
        @mouseleave="codeShow = false"
      >
        <i class="iconfont icon-weixin"></i>
        <a href="javascript:void(0)">
          <span class="weChat">
            {{ $t("footer.weChart") }}
          </span>
        </a>
      </div>
    </div>
    <transition name="fade">
      <wechat-public v-show="codeShow" class="wechat-code"></wechat-public>
    </transition>

    <transition name="fade">
      <we-public v-show="weiBoShow" class="wechatde"></we-public>
    </transition>
  </div>
</template>

<script>
import WechatPublic from "./components/wechat-public";
import WePublic from "./components/we-public";
export default {
  props: {
    isShowLogo: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      codeShow: false,
      weiBoShow: false,
      weChatShow: false,
      currentYear: 2025
    };
  },
  components: {
    WechatPublic,
    WePublic
  },
  mounted() {
    this.currentYear = new Date().getFullYear();
    this.currentYear =
      this.currentYear == undefined || null ? 2025 : this.currentYear;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss">
@import "~@/styles/base.scss";
.foot {
  position: relative;
  min-width: 1200px;
  padding-top: 30px;
  height: 110px;
  .logo {
    float: left;
    // display: inline-block;
    box-sizing: border-box;
    padding-top: 17px;
    margin: 0 25px 0 20px;
    height: 88px;
    img {
      width: 200px;
      line-height: 88px;
    }
  }
  .introduce {
    float: left;
    padding-top: 20px;
    font-size: 16px;
    color: $grayColor;
    ul {
      li {
        margin-right: 40px;
        float: left;
        line-height: 1em;
      }
    }
    p {
      margin-top: 8px;
      font-size: 14px;
      color: #a9a9a9;
    }
  }
  .followus {
    div {
      display: block;
      float: right;
      margin-left: 30px;
      margin-top: 10px;
      text-align: center;
      span {
        display: block;
        margin-top: 10px;
        line-height: 1em;
        font-size: 14px;
        color: #333;
      }
      .iconfont {
        height: 30px;
        display: block;
        cursor: pointer;
        font-size: 36px;
        /*color: #D8E4ED;*/
      }
    }
  }
  .follow-weiBo:hover,
  .follow-weChat:hover {
    .iconfont {
      color: $layoutBlue;
    }
  }
  .wechat-code {
    position: absolute;
    z-index: 20;
    right: 0px;
    bottom: 120px;
  }

  .wechatde {
    position: absolute;
    z-index: 20;
    right: 0px;
    bottom: 120px;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.15s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/foot/foot.vue